import { render, staticRenderFns } from "./PoseCanvasCopy.vue?vue&type=template&id=015e4b7b&scoped=true&"
import script from "./PoseCanvasCopy.vue?vue&type=script&lang=js&"
export * from "./PoseCanvasCopy.vue?vue&type=script&lang=js&"
import style0 from "./PoseCanvasCopy.vue?vue&type=style&index=0&id=015e4b7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015e4b7b",
  null
  
)

export default component.exports